import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const BrandingContext = createContext(null);
const API_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULT_LOGO = '/cpdforge-icon.webp';

const DEFAULT_BRANDING = {
  company_name: 'CPDForge AI',
  primary_color: '#4338ca',
  logo_base64: DEFAULT_LOGO
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const [loading, setLoading] = useState(false);
  const { token, user } = useAuth();

  const fetchBranding = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/branding`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBranding(res.data);
    } catch {
      setBranding(DEFAULT_BRANDING);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (user && token) {
      fetchBranding();
    } else {
      setBranding(DEFAULT_BRANDING);
    }
  }, [user, token, fetchBranding]);

  const updateBranding = async (updates) => {
    const res = await axios.put(`${API_URL}/api/branding`, updates, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setBranding(res.data);
    return res.data;
  };

  return (
    <BrandingContext.Provider value={{ branding, loading, updateBranding, fetchBranding }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error('useBranding must be used within BrandingProvider');
  }
  return context;
};
